// extracted by mini-css-extract-plugin
module.exports = {"body":"_1xnDElcNVYa0xgSIi6yVMt","dialog":"txkkIG7_tobz_ITTZSNsc"};